import { c as _c } from "react/compiler-runtime";
import { FeatherInfo } from '@subframe/core';
import type { GrupoPartesSentenca } from '../../../types/sentencaArbitral.types';
import { TEXTOS_SENTENCA_ARBITRAL } from './secoesSentencaArbitral';
export function SecaoPartesIntro() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="px-[37px] pb-6"><p className="text-[14px] leading-[1.45] text-neutral-600">{TEXTOS_SENTENCA_ARBITRAL.partesIntro}</p></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
interface TabelaGrupoPartesSentencaProps {
  grupo: GrupoPartesSentenca;
}
const COLUNAS = 'grid-cols-[1.9fr_0.8fr_1.5fr_1.25fr]';
export function TabelaGrupoPartesSentenca(t0) {
  const $ = _c(19);
  const {
    grupo
  } = t0;
  const corDestaque = grupo.destaque === "coral" ? "bg-coral-500" : "bg-brand-600";
  const corTitulo = grupo.destaque === "coral" ? "text-coral-500" : "text-brand-600";
  const t1 = `h-2 w-2 flex-none rounded-[2px] ${corDestaque}`;
  let t2;
  if ($[0] !== t1) {
    t2 = <span className={t1} />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `text-[12px] font-bold tracking-[0.8px] uppercase ${corTitulo}`;
  let t4;
  if ($[2] !== grupo.titulo || $[3] !== t3) {
    t4 = <span className={t3}>{grupo.titulo}</span>;
    $[2] = grupo.titulo;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t2 || $[6] !== t4) {
    t5 = <div className="mb-[13px] flex items-center gap-[9px]">{t2}{t4}</div>;
    $[5] = t2;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className={`bg-brand-50 grid ${COLUNAS} px-5 py-[11px] text-[11px] font-semibold tracking-[0.5px] text-neutral-500 uppercase`}><div>Nome</div><div>Papel</div><div>Contato</div><div>Documento</div></div>;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== grupo.partes) {
    t7 = grupo.partes.map(_temp2);
    $[9] = grupo.partes;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== grupo.observacao) {
    t8 = grupo.observacao ? <div className="flex items-center gap-2 border-t border-solid border-neutral-200 bg-neutral-50 px-5 py-2.5"><FeatherInfo className="h-3.5 w-3.5 flex-none text-neutral-400" /><span className="text-[11.5px] text-neutral-500">{grupo.observacao}</span></div> : null;
    $[11] = grupo.observacao;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t7 || $[14] !== t8) {
    t9 = <div className="overflow-hidden rounded-[8px] border border-solid border-neutral-200">{t6}{t7}{t8}</div>;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t5 || $[17] !== t9) {
    t10 = <div className="px-[37px] pb-[26px]">{t5}{t9}</div>;
    $[16] = t5;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
}
function _temp2(parte) {
  return <div className={`grid ${COLUNAS} items-center border-t border-solid border-neutral-200 px-5 py-4`} key={parte.id}><div className="text-brand-600 pr-[14px] text-[13px] leading-[1.35] font-semibold">{parte.nome}</div><div><span className={parte.papelDestacado ? "text-brand-600 bg-brand-600/10 rounded-[5px] px-[10px] py-[3px] text-[11px] font-semibold" : "rounded-[5px] border border-solid border-neutral-300 px-[10px] py-[3px] text-[11px] font-semibold text-neutral-500"}>{parte.papelLabel}</span></div><div className="pr-[14px] text-[12px] leading-[1.55] break-words text-neutral-700">{parte.contatos.map(_temp)}</div><div className="text-[12px] whitespace-nowrap text-neutral-700">{parte.documento}</div></div>;
}
function _temp(contato) {
  return <div key={contato}>{contato}</div>;
}